import React, {Component} from 'react';
import PropTypes from "prop-types";
import _ from 'lodash';

import {COLUMN_SHAPE} from '../../utilities/columns'
import {TEXT} from '../../utilities/strings'

/**
 * Component to render the content for an individual table cell,
 * called by DetailTable and SelectionTable
 *
 * @example
 * <TableCell key={col.field} column={col} value={model}/>
 */
export default class TableCell extends Component {

  static propTypes = {
    column: COLUMN_SHAPE,
    value: PropTypes.object,
    isSelected: PropTypes.bool,
    isComparison: PropTypes.bool
  };

  render() {
    const col = this.props.column || {};

    let value = _.get(this.props.value, col.field, '');

    if (value && col.format) {
      value = col.format(value);
    }

    if (col.isHeader && this.props.isSelected) {
      value = <span>{value} <small>&nbsp; {TEXT.selected_indicator} </small></span>
    } else if (col.isHeader && this.props.isComparison) {
      value = <span>{value} <small>&nbsp; {TEXT.comparison_indicator}</small></span>
    }

    if (col.isHeader) {
      return <th role="rowheader" scope="row" className={col.className}>{value}</th>
    } else {
      // eslint-disable-next-line jsx-a11y/no-interactive-element-to-noninteractive-role
      return <td role="cell" className={col.className}>{value}</td>
    }
  }
}
